import { CommonModule, Location } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { RouterOutlet } from '@angular/router'
import { AbstractComponent } from '@monorepo-channels/channels/domain'
import { DataLayerService } from '@monorepo-channels/shared/util-helpers'

@Component({
	selector: 'porto-bank-privacy-policy-page',
	standalone: true,
	imports: [MatButtonModule, CommonModule, RouterOutlet, MatIconModule],
	templateUrl: 'privacy-policy.page.html',
	styleUrls: ['privacy-policy.page.scss'],
})
export class PrivacyPolicyPageComponent extends AbstractComponent implements OnInit {
	public location = inject(Location)
	private dataLayerService = inject(DataLayerService)

	ngOnInit(): void {
		this.dataLayerService.logEvent({
			event: 'screen_view',
			screen_name: 'Gastronomia Porto Bank - Política de Privacidade',
		})
	}
}
